module.exports = __webpack_public_path__ + "img/attendance.036424af.jpg";